import React, { Fragment } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { H4, HighlightGroup } from '@contently/toolkit';
import { object, string } from 'yup';
import AssignedStories from './assigned_stories';
import * as actions from '../../store/actions/index';
import ReassignUsersForm from './reassign_users_form';
import ConfirmationModal from './confirmation_modal';
import ReassignmentProgress from './reassignment_progress';

export class ReassignUsersContainer extends React.Component {
  componentDidMount() {
    const {
      appData,
      setBrandProfileId,
      fetchEligibleUsers,
      persistedJobStatuses,
      handleJobRestart
    } = this.props;
    const brandProfileId = JSON.parse(appData).brandProfileId;

    if (persistedJobStatuses[brandProfileId]) {
      const { jobId, fromUser, toUser } = persistedJobStatuses[brandProfileId];
      handleJobRestart(jobId, brandProfileId, fromUser, toUser);
    }

    setBrandProfileId(brandProfileId);
    fetchEligibleUsers(brandProfileId);
  }

  handleReassignSubmit = (values) => {
    const {
      brandProfileId,
      toggleModal,
      startReassignmentJob
    } = this.props;
    const fromUser = values.fromUser;
    const toUser = values.toUser;

    toggleModal();
    startReassignmentJob(brandProfileId, fromUser, toUser);
  }

  handleSubmitClick = (values) => {
    const { toggleModal } = this.props;
    if (values.fromUser.value !== values.toUser.value) toggleModal();
  }

  render() {
    const { currentJobStatus, appData } = this.props;
    const { fromUser } = JSON.parse(appData);

    if (currentJobStatus) {
      return <ReassignmentProgress />;
    }

    return (
      <Formik
        initialValues={{
          fromUser: fromUser || '',
          toUser: ''
        }}
        validationSchema={object().shape({
          fromUser: string().required('User to reassign is required'),
          toUser: string().required('User to reassign stories to is required')
        })}
        onSubmit={values => this.handleSubmitClick(values)}
        render={innerProps => (
          <Fragment>
            <HighlightGroup>
              <H4>Bulk reassign quickly allows you to reallocate work from one person to another. This tool enables you to reassign workflow steps for all stories still in progress at the click of a button.</H4>
              <ReassignUsersForm
                handleSubmit={innerProps.handleSubmit}
                setFieldValue={innerProps.setFieldValue}
                setFieldTouched={innerProps.setFieldTouched}
                values={innerProps.values}
                errors={innerProps.errors}
                touched={innerProps.touched}
              />
            </HighlightGroup>
            <AssignedStories />
            <ConfirmationModal
              fromUser={innerProps.values.fromUser.label}
              toUser={innerProps.values.toUser.label}
              onConfirm={() => { this.handleReassignSubmit(innerProps.values); }}
            />
          </Fragment>
        )}
      />
    );
  }
}

ReassignUsersContainer.defaultProps = {
  brandProfileId: null,
  currentJobStatus: null,
  persistedJobStatuses: null
};

ReassignUsersContainer.propTypes = {
  appData: PropTypes.string.isRequired,
  brandProfileId: PropTypes.number,
  currentJobStatus: PropTypes.object,
  persistedJobStatuses: PropTypes.object,
  setBrandProfileId: PropTypes.func.isRequired,
  fetchEligibleUsers: PropTypes.func.isRequired,
  handleJobRestart: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  startReassignmentJob: PropTypes.func.isRequired
};

const mapStateToProps = state => (
  {
    brandProfileId: state.reassignUsers.brandProfileId,
    confirmModalOpen: state.reassignUsers.confirmModalOpen,
    reassignmentInProgress: state.reassignUsers.reassignmentInProgress,
    currentJobStatus: state.reassignUsers.currentJobStatus,
    persistedJobStatuses: state.reassignUsers.persistedJobStatuses
  }
);

const mapDispatchToProps = dispatch => (
  {
    setBrandProfileId: id => dispatch(actions.setBrandProfileId(id)),
    fetchEligibleUsers: id => dispatch(actions.fetchEligibleUsers(id)),
    toggleModal: () => dispatch(actions.toggleConfirmModal()),
    handleJobRestart: (jobId, brandProfileId, fromUser, toUser) => (
      dispatch(actions.handleJobRestart(jobId, brandProfileId, fromUser, toUser))
    ),
    startReassignmentJob: (bpId, fromUser, toUser) => (
      dispatch(actions.startReassignmentJob(bpId, fromUser, toUser))
    )
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(ReassignUsersContainer);



// WEBPACK FOOTER //
// ./app/javascript/app/components/reassign_users/reassign_users_container.jsx